package com.patronat.top.client.presentation.home.components

import com.patronat.top.dto.VenueResponse
import kotlin.math.roundToInt

internal fun VenueResponse.ratingSummaryText(): String {
    return "${averageRating.ratingValueText()} (${reviewsCount.compactCountText()})"
}

internal fun VenueResponse.averageRatingText(): String = averageRating.ratingValueText()

internal fun Long.compactCountText(): String {
    return when {
        this >= 1_000_000L -> "${(this / 1_000_000.0).compactDecimalText()}m"
        this >= 1_000L -> "${(this / 1_000.0).compactDecimalText()}k"
        else -> toString()
    }
}

private fun Double.ratingValueText(): String {
    val rounded = (this * 10).roundToInt()
    return "${rounded / 10}.${rounded % 10}"
}

private fun Double.compactDecimalText(): String {
    val rounded = (this * 10).roundToInt()
    val whole = rounded / 10
    val decimal = rounded % 10
    return if (decimal == 0) whole.toString() else "$whole.$decimal"
}
